import { render, staticRenderFns } from "./halfText.vue?vue&type=template&id=4fee4d48&scoped=true"
import script from "./halfText.vue?vue&type=script&lang=ts"
export * from "./halfText.vue?vue&type=script&lang=ts"
import style0 from "./halfText.vue?vue&type=style&index=0&id=4fee4d48&prod&scoped=true&lang=css"
import style1 from "./halfText.vue?vue&type=style&index=1&id=4fee4d48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fee4d48",
  null
  
)

export default component.exports